import "packages/frontend/core/src/desktop/dialogs/setting/admin-setting/style.css.ts.vanilla.css!=!../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/admin-setting/style.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA-VYS4_bNhC-768gEBTYHBhIsq24zCXIH8glQI8FLQ5txhSpkpQfKfLfC1G2RVmSX-t1u81lZUjz4sx838zy8xK23NAcLPozgUJH0Qb9_YSQ0_6BkDNUWa5NTpDRjjp4HqURg_n7T08I_Xz6-fRhpxd5BSZsIemWIC5hU4lUT8yEgcwJrQjKtCxzVX2Z04KgZFxsPgVW4n4rXnZa-N9UirnCwkFuCcpAOTDV65yauVB4pp3T-UHYu1-bSr36G7pKvKtKgKDYWxAKrwVzC4LiaVTrF5QxoebeHoqT-uVMGwYGG8pEaQ-u6rcExcUGWS0FQytqnjGmnAsFeJVgSbdgsFBWMPhS26iVfDJnNFvOjS4VIwOajQQujMip2XpFrpXDVvyAI736fe5ldOmkUECQ0gqqF5mW2nQdOdi4wHiQLcJ1Vlqfs935B0zMSue0GjBCCkkzWGjJwHhbJ-NoZFtmRmEU-yocinNrGl9aP70Cw6VeE7QQjIEKIx77iA_NVMWK4rQOuNPs-x6Mot8G-z0wTRaV5zol15zdq31dgZG0XaUxUdo9E0mtw5pjty3gfZjxPcRuS1TjZ3ICgFFvZobJZId-Cdw1rXCqImnt_ALoXIaUPm8IeaHmA0gpCiusr_JCOMC2oJlHZc1OCFUoxQsQ84UjKEna7PjxfNAbezZoC5lW7DXDjtphT_tJfYDIQ67vLavvArswQi19ozSOfm_DrELZtJeyxztLF2TS_17vTjaJonMc06G_wWLsJUsDf1RZ_QYb1wII7c_b99I6wbc408qBcgT5auAZuDXU9RvIbGuYRZeOjktbqYl7dm6IN6LZTVvDvhMaQk17y_wvz4TmmOymYx7tRvAK6O92d-OPt9H0q29A_B4b0Pz8ftuBt-8SUCwgRKe77bF4LbYItpXA24OWBHHbvxXtYL_ffdifws3y7jhtbMsLi9yU8Vx1RztIX8kZJ_PYxJu_uVVd3XtV38-sIwCpu-_t6kGQ1Md7-xXoPJX54i2u5H-9zZXcPGoltw9ZyRt_rgOod5DyMdCgBO9i-AijcahWdtV4BlNIQ7VskiQxD9VWPd6mPOLQ8kYnKZuFauvrs99ZeaubswMxDfJ_43Prfe4IK9ldb7XboyHW5NYNrn7jdHHxbtRphMmOS5XIaU0fh5vJ6MPU-r6mBgnFhRIOwjP-uAuD9E_e-OiCcyZ1tjxeydKjIqVVjaLefk9vmIFtmrhqV7kEUpzmQm77pOovONdKe_G1NgzPDNAlQf6BqZStbMU3ZGv6f81WSNCFgZDj8YYgWjrdSl7yoHuMY9o-nWDrqCsttmWWgT05087ebMSj__IJwRhtXna-8fUMn54bpfHk7vQ2sDwEPtNwbMSTqD_Iy0D8S1wTxOkL7gn-AXnykrePGwAA\"}!../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var adminBadge = '_2epo009';
export var adminPanel = '_2epo000';
export var backupActions = '_2epo00r';
export var backupInfo = '_2epo00o';
export var backupMeta = '_2epo00q';
export var backupName = '_2epo00p';
export var backupRow = '_2epo00n';
export var backupTable = '_2epo00m';
export var createUserForm = '_2epo00c';
export var csvExample = '_2epo0011';
export var csvNgBadge = '_2epo0013';
export var csvOkBadge = '_2epo0012';
export var dateInput = '_2epo0016';
export var dateRange = '_2epo0014';
export var dateRangeLabel = '_2epo0015';
export var emptyState = '_2epo00l';
export var formActions = '_2epo00g';
export var formInput = '_2epo00f';
export var formLabel = '_2epo00e';
export var formRow = '_2epo00d';
export var pagination = '_2epo00a';
export var paginationButtons = '_2epo00b';
export var restoreProgress = '_2epo00w';
export var restoreSpinner = '_2epo00y';
export var restoreStepText = '_2epo00z';
export var searchBar = '_2epo001';
export var searchInput = '_2epo002';
export var settingDesc = '_2epo00k';
export var settingItem = '_2epo00h';
export var settingLabel = '_2epo00i';
export var settingName = '_2epo00j';
export var ssoRedirectUri = '_2epo0010';
export var statusBadge = '_2epo00s';
export var statusCompleted = '_2epo00t';
export var statusFailed = '_2epo00u';
export var statusRunning = '_2epo00v';
export var userActions = '_2epo008';
export var userEmail = '_2epo007';
export var userInfo = '_2epo005';
export var userName = '_2epo006';
export var userRow = '_2epo004';
export var userTable = '_2epo003';